import { handleAxiosError } from "@/lib/handleAxiosError";
import { reportAxiosError } from "@/lib/reportAxiosError";
import { getApiUrl } from "@/lib/utils";
import axios, { InternalAxiosRequestConfig } from "axios";
import { getCookie } from "cookies-next";

const client = axios.create({
  baseURL: getApiUrl() + "/api",
  withCredentials: true,
});

const addHeaders = (request: InternalAxiosRequestConfig) => {
  const token = getCookie("token");
  if (token) {
    request.headers["Authorization"] = `Bearer ${token}`;
  }
  const csrfToken = getCookie("XSRF-TOKEN");
  if (csrfToken) {
    request.headers["X-XSRF-TOKEN"] = csrfToken;
  }
  const locale = localStorage.getItem("locale") ?? "ja";
  request.headers["Accept-Language"] = locale;
};

client.interceptors.request.use(
  async (request) => {
    if (request.url === "/console/login" || request.url === "/app/login") {
      await client.get(getApiUrl() + "/sanctum/csrf-cookie");
    }
    addHeaders(request);
    return request;
  },
  (error) => {
    return Promise.reject(error);
  },
);

client.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    reportAxiosError(error);
    return Promise.reject(handleAxiosError(error));
  },
);

export default client;
